import { render, staticRenderFns } from "./LogListItem.vue?vue&type=template&id=2f240822&"
import script from "./LogListItem.vue?vue&type=script&lang=js&"
export * from "./LogListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LogListItem.vue"
export default component.exports